import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogPaper from '../DialogPaper';

export interface Values {
  pin: string;
  stampNum: string;
}

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    width: 80,
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: 300,
  },
  title: {
    marginTop: theme.spacing(3),
    fontWeight: theme.typography.fontWeightBold,
  },
  subtext: {
    marginTop: theme.spacing(2),
    color: '#6E6E6E',
    textAlign: 'center',
    padding: theme.spacing(),
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 0.5)',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  stampCardName: string;
  confirmDelete: () => void;
  onCancel: () => void;
};

export default function DeleteCardDialog({
  onClose,
  open,
  confirmDelete,
  stampCardName,
  onCancel,
}: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={DialogPaper}>
      <div className={classes.cardContainer}>
        <Typography variant="h5" className={classes.title} gutterBottom>
          Permanently Delete Card?
        </Typography>
        <Typography variant="body1" className={classes.subtext} gutterBottom>
          {`You are about to permanently delete this "${stampCardName}". All stamp progress will be lost. This action cannot be undone.`}
        </Typography>
      </div>
      <div className={classes.actionContainer}>
        <Button onClick={() => onCancel()} className={classes.buttonContainer}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => confirmDelete()}
          className={classes.buttonContainer}
        >
          Delete
        </Button>
      </div>
    </Dialog>
  );
}
